import { MeshGradientSVG } from './shader-svg'

/**
 * The ghost mascot, pinned to the centre of the viewport behind all content.
 * Sits above the aurora (-z-10) and below <main> / <footer>.
 */
export function GhostBackdrop() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-[5] grid place-items-center">
      <div className="relative w-72 scale-75 text-white opacity-40 md:scale-100 md:opacity-60 [@media(max-height:700px)]:scale-[0.6]">
        {/* soft halo so the ghost glows into the aurora */}
        <div className="absolute inset-[-30%] rounded-full bg-[radial-gradient(closest-side,rgba(196,181,253,0.22),transparent)] blur-2xl" />
        <MeshGradientSVG />
      </div>
    </div>
  )
}
